/**
 * Endpoint de Completadas de Despacho — solo lectura, GET /api/despacho/completadas.
 * Devuelve los trazados exitosos (status='success') más recientes primero.
 */

import { apiFetch } from '@/api/http';
import {
  GetCompletadasResponse,
  type TrazaCompletada,
} from '@/api/contracts/despacho-completadas';

export async function getDespachoCompletadas(): Promise<TrazaCompletada[]> {
  const data = await apiFetch<unknown>('/despacho/completadas', { auth: true });
  return GetCompletadasResponse.parse(data);
}
